import { Ability } from '@casl/ability';

const supplyRoles = [
  'ROLE_MANUFACTURER',
  'ROLE_AGENT',
  'ROLE_DISTRIBUTOR',
  'ROLE_REPRESENTATIVE',
];
const demandRoles = [
  'ROLE_DESIGNER_LIGHTING',
  'ROLE_ELECTRICAL_ENGINEER',
  'ROLE_ARCHITECT',
  'ROLE_INTERIOR_DESIGNER',
  'ROLE_AV_DESIGNER',
];
const adminRoles = ['ROLE_SUPER_ADMIN'];

export const definePrivileges = (role = []) => {
  const defaultAbility = new Ability([]);

  const isSupply = role.some(item => supplyRoles.includes(item));
  const isAdmin = role.some(item => adminRoles.includes(item));
  const isDemand = role.some(item => demandRoles.includes(item));

  if (isSupply) {
    return defaultAbility.update([{ subject: 'supply', actions: 'see' }]);
  }
  if (isDemand) {
    return defaultAbility.update([{ subject: 'demand', actions: 'see' }]);
  }

  if (isAdmin) {
    return defaultAbility.update([{ subject: 'admin', actions: 'see' }]);
  }

  return defaultAbility;
};

export const getDefaultRouteForRole = role => {
  const isSupply = role.some(item => supplyRoles.includes(item));
  const isAdmin = role.some(item => adminRoles.includes(item));
  const isDemand = role.some(item => demandRoles.includes(item));
  if (isSupply) {
    return '/supply';
  }
  if (isDemand) {
    return '/demand';
  }

  if (isAdmin) {
    return '/admin';
  }

  return '/';
};
